/** User-facing strings: download. */
export const download = {
    metadataTitle: "Download Agent",
    title: "Download the OPC UA Relay Agent",
    description:
        "The agent runs on one machine inside your network and opens an outbound connection to the relay. Nothing needs to be installed on your OPC UA servers.",
    install: {
        heading: "Install and enrol",
        signedInOnly: "The executables are for signed-in users of this dashboard only.",
    },
    needs: {
        heading: "What you need",
        intro: "A checklist you can hand to your IT team.",
        machine: {
            lead: "One machine inside your network",
            rest: "that can reach your OPC UA servers, running Windows x64, Linux x64, Linux arm64, or Docker on Linux.",
        },
        outbound: {
            lead: "Outbound access only.",
            rest: "Allow these connections from that machine:",
            region: "Outbound connections",
            caption: "Outbound connections made by the agent",
            host: "Host",
            port: "Port",
            protocol: "Protocol",
            purpose: "Purpose",
            enrolment: "Enrolment and registration. Short requests.",
            tunnel: "The tunnel. One long-lived connection, kept alive every 5 seconds.",
            servers: "Your OPC UA servers",
            serversPort: "Their own, often TCP 4840",
            serversProtocol: "OPC UA over TCP",
            serversPurpose: "Inside your network, only the servers you list.",
        },
        inbound: {
            lead: "No inbound port.",
            rest: "The agent listens on nothing in its normal operation (only the optional Reverse Connect listener opens a port, and only when you set it up), so no inbound firewall rule or port forwarding is needed.",
        },
        hostname: {
            lead: "Allow by hostname.",
            before: "Sterfive does not publish IP addresses yet. If your firewall filters by web category, allow",
            after: "explicitly: a little-known host may be blocked as uncategorised.",
        },
        tls: {
            lead: "No TLS inspection on the tunnel.",
            before: "The agent checks the relay's certificate (from version 0.1.2) and refuses a certificate re-signed by a proxy: exempt",
            after: "from inspection.",
        },
        proxy: {
            lead: "No forward proxy.",
            before: "The agent ignores",
            after: "and system proxy settings today, so it needs a direct outbound path to the two hosts above.",
        },
        account: {
            lead: "An account on this dashboard",
            rest: ", to approve the agent when you enrol it.",
        },
    },
    next: {
        heading: "Next step: enrol the agent",
        before: "Once the agent is installed, run",
        after: "with your personal token, then approve the device in your browser when the agent shows its address and code.",
        getToken: "Get your token",
    },
    platforms: {
        label: "Platform",
    },
    enrol: {
        title: "Enrol the agent",
        copyBefore: "Copy your token from",
        tokenLink: "Your Token",
        runBefore: ", then run the command with the token in place of",
        runAfter:
            ". The agent prints an address and a code (and opens your browser when it can): approve the device on that page, and the agent is enrolled.",
        command: "Enrol command",
    },
    file: {
        downloadTitle: "Download and check the file",
        headlessBefore: "For a machine without a browser, use",
        headlessMiddle: ": it gives a",
        headlessAfter: "command, valid for 10 minutes, to run on that machine.",
        checkBefore: "Check the download before you run it. In the folder that holds it, this command must answer",
        checkAfter: "; if it does not, delete the file.",
        verify: "Verify the SHA-256",
        signatureIntro: "Releases of the Windows executable carry Sterfive's signature:",
        signatureMustBe: "must be",
        signatureSigner: ", with Sterfive as the signer.",
        signatureNotSigned:
            "means this release is not signed: Windows SmartScreen then warns about an unknown publisher, and the SHA-256 check above still applies.",
        checkSignature: "Check the signature",
        renameWindows: "Rename it, so the commands below match:",
        renameLinux: "Rename it and make it executable, so the commands below match:",
        prepare: "Prepare command",
        versionBefore: "Check the installation first with",
        versionAfter: ". An agent that is already enrolled needs",
        versionEnd: "to enrol again.",
        publishTitle: "Publish an OPC UA server",
        publishIntro: "Start the agent and name the server it may reach. Keep it running: closing it closes the tunnel.",
        serve: "Serve command",
        arm64Note:
            "The arm64 file is built with the other two, but the release pipeline only checks that it is a valid arm64 executable: it does not run it.",
    },
    docker: {
        introBefore: "The same agent as a container image for Linux gateways (",
        introAnd: "and",
        introAfter: "), running as a non-root user with its enrolment kept on a Docker volume. Image:",
        privateLead: "The image registry is private.",
        privateBefore:
            "You pull with a read-only token that Sterfive issues to you. Use the release version shown on the other tabs in place of",
        privateMiddle: ": there is no",
        privateAfter: "tag.",
        pullTokenTitle: "Get a pull token",
        pullTokenIntro: "Ask Sterfive for a registry access token.",
        contact: "Contact Sterfive",
        contactNewTab: "(opens Sterfive's contact page in a new tab)",
        loginTitle: "Log in to the registry",
        loginIntro: "Docker asks for the token as the password, so it does not stay in your shell history.",
        loginLabel: "Log in to {host}",
        volume: "Create the data volume",
        noBrowser:
            "The container has no browser: the command prints the address and the code, open the address from any device and approve it there.",
        runTitle: "Run the agent",
        run: "Run command",
        publishBefore:
            "Then name each server it may reach. The server must be reachable from inside the container (the same Docker network, or",
        publishAfter: "on Linux).",
        publish: "Publish a server",
    },
    agents: {
        loading: "Looking up the current agent release...",
        unavailable: "{message}. For early access, contact Sterfive.",
        unreachable: "The dashboard could not be reached",
        noFile: "Release {version} has no file for {platform}.",
        sectionLabel: "Agent {version} downloads",
        currentRelease: "Current release:",
        download: "Download",
        headless: "Link for a headless machine",
        linkLabel: "Get a 10-minute download link for {platform}",
        sha256: "SHA-256",
        copySha: "Copy the SHA-256 of {name}",
        runOnTarget: "Run on the target machine",
        copyDownloadCommand: "Copy the download command for {platform}",
        validUntil: "Valid until {time}. Anyone with this link can download the file until then: do not share it.",
    },
};
